import React, { useState } from "react";

import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";

import "moment/locale/pt-br";
import "./styles.css";

import AtendimentosAbertos from "./AtendimentosAbertos";
import AtendimentosFechados from "./AtendimentosFechados";

function GestaoAtendimentos() {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    return (
        <>
            <div className="card card-custom gutter-b">
                <div className="card-header card-header-tabs-line">
                    <div className="card-toolbar">
                        <ul className="nav nav-tabs nav-bold nav-tabs-line">
                            <li className="nav-item">
                                <a
                                    className="nav-link active"
                                    data-toggle="tab"
                                    href="#AtendimentosFechados"
                                >
                                    <span className="nav-icon">
                                        <i className="flaticon-interface-3"></i>
                                    </span>
                                    <span className="nav-text">
                                        Atendimentos Fechados
                                    </span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a
                                    className="nav-link"
                                    data-toggle="tab"
                                    href="#AtendimentosEmAberto"
                                >
                                    <span className="nav-icon">
                                        <i className="flaticon2-chat-1"></i>
                                    </span>
                                    <span className="nav-text">
                                        Atendimentos em Aberto
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="card-body">
                    <div className="tab-content">
                        <div
                            className="tab-pane fade show active"
                            id="AtendimentosFechados"
                            role="tabpanel"
                            aria-labelledby="AtendimentosFechados"
                        >
                            <AtendimentosFechados
                                setModal={setModal}
                                setShow={setShow}
                            />
                        </div>
                        <div
                            className="tab-pane fade"
                            id="AtendimentosEmAberto"
                            role="tabpanel"
                            aria-labelledby="AtendimentosEmAberto"
                        >
                            <AtendimentosAbertos />
                        </div>
                    </div>
                </div>
            </div>
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}
export default GestaoAtendimentos;
